import {generateUrl} from "v4/services/api.service";
import {CORE_TAG_CHANGE_STATUS} from "v4/data/apiRoutes";
import {asyncDebounce} from "v4/utils/debounce";
import {ulid} from "ulid";
import jsonToFormData from "v4/utils/jsonToFormData";
import {NotificationContextExternal} from "v4/contexts/NotificationContext";
import i18n from "i18next";

export function createActionTagSpan({
                                        createdBy,
                                        userId,
                                        userFullname,
                                    }, editor) {
    const actionTagSpan = editor.contentDocument.createElement('span');

    actionTagSpan.classList.add('user-tag');

    actionTagSpan.setAttribute('data-role', 'editor-action-tag');
    actionTagSpan.setAttribute('data-tag-id', ulid());
    actionTagSpan.setAttribute('data-tag-tagged-from', createdBy);
    actionTagSpan.setAttribute('data-tag-tagged-to', userId);

    actionTagSpan.innerHTML = `@${userFullname}`;

    return actionTagSpan;
}

export function renderEditorActionTag(editorActionTagElement, tagInfos = {}, isShow = false) {
    const userFullName = editorActionTagElement.innerText.replace('@', '');
    editorActionTagElement.contentEditable = 'false';

    editorActionTagElement.innerHTML = `
        <label class="user-tag-label ${tagInfos.canDone ? '' : 'is-disabled'}" ${tagInfos.canDone ? '' : `title="${i18n.t('CORE_TAGS_PREVENT_CLOSING_BY_OTHER_USERS')}"`}>
            @${userFullName}
            ${isShow ? `<input type="checkbox" ${tagInfos.canDone ? 'contenteditable="true"' : `disabled`} ${tagInfos.done ? 'checked' : ''}>` : ''}
        </label>
    `;

    // Prevent the cursor to be stuck in the user-tag
    editorActionTagElement.after(document.createElement('span'));

    const inputCheckbox = editorActionTagElement.querySelector('input[type=checkbox]');

    if (!inputCheckbox) return;

    inputCheckbox.addEventListener('change', e => onActionTagCheck(e, tagInfos));
}

async function onActionTagCheck(event, tagInfos) {
    const checkboxElement = event.currentTarget;

    const request = await asyncDebounce(() =>
        fetch(generateUrl(CORE_TAG_CHANGE_STATUS, {id: tagInfos.id}), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
            },
            body: jsonToFormData({
                'tag_status[done]': checkboxElement.checked,
            })
        })
    );

    if (!request.ok) {
        // Revert the checkbox state if the request failed
        checkboxElement.checked = !checkboxElement.checked;

        const {detail} = await request.json();
        return NotificationContextExternal.addErrorNotification(detail);
    }

    const {title} = await request.json();
    NotificationContextExternal.addSuccessNotification(title);
}
